/**
 * DashboardCard — quadrant container for the Command Dashboard.
 *
 * COORD-26: Theme-aware card with header and scrollable content area.
 * Minimal shell: navy left-accent border, typography-led hierarchy.
 */

const BRAND_NAVY = "#09244B";

export default function DashboardCard({ title, subtitle, icon, children }) {
  return (
    <div
      className="flex flex-col rounded-xl border border-neutral-200/70 dark:border-slate-700/70 bg-white dark:bg-slate-800/80 overflow-hidden"
      style={{ borderLeftColor: BRAND_NAVY, borderLeftWidth: "3px" }}
    >
      {/* Card header */}
      <div className="flex items-stretch border-b border-neutral-200/80 dark:border-slate-700 flex-shrink-0 bg-gray-50/50 dark:bg-slate-800/90">
        <div className="flex items-center justify-between flex-1 min-w-0 px-4 py-3">
          <div className="flex items-center gap-2.5">
            {icon && (
              <div
                className="w-6 h-6 rounded-md flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: `${BRAND_NAVY}18`, color: BRAND_NAVY }}
              >
                <div className="w-3.5 h-3.5 dark:opacity-90">
                  {icon}
                </div>
              </div>
            )}
            <div>
              <h3 className="text-[11px] font-semibold uppercase tracking-widest text-neutral-600 dark:text-slate-300">
                {title}
              </h3>
              {subtitle && (
                <p className="text-[10px] mt-0.5 text-neutral-400 dark:text-slate-500">{subtitle}</p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Content — capped so one card can't grow past a readable size; each
          list inside caps its own items and links out to the full view. */}
      <div className="max-h-[380px] overflow-y-auto">
        {children}
      </div>
    </div>
  );
}
